import { ChatResponseType } from '@trinity/chat';
import type { Chat } from '@trinity/chat';
import { markdownToRawText } from './markdown';

export function getSegmentationQueryResponseAsText(
  results: Array<{
    dimension: string;
    findings: Array<{
      label: string;
      response: Chat.QueryResponse;
    }>;
  }>,
): string {
  let buffer = '';

  for (const result of results) {
    buffer += `${result.dimension}\n\n`;
    for (const finding of result.findings) {
      buffer += `${finding.label}:\n\n`;
      const text = getQueryResponseAsText(finding.response);
      buffer += `${text}\n\n`;
    }
    buffer += `\n`;
  }

  return buffer;
}

export function getQueryResponseAsText(response: Chat.QueryResponse): string {
  switch (response.type) {
    case ChatResponseType.Text: return response.value;
    case ChatResponseType.Markdown: return markdownToRawText(response.value);
    case ChatResponseType.MarkdownHtml: return markdownToRawText(response.value);
    case ChatResponseType.HcpAvailability: return ''; // TODO: Implement
    case ChatResponseType.HcpSummary: return ''; // TODO: Implement
    case ChatResponseType.HcpSelection: return ''; // TODO: Implement
    case ChatResponseType.LocationSelection: return ''; //TODO: Implement
    case ChatResponseType.Chart: return response.data.chart.response; //TODO: Implement
    case ChatResponseType.LocationRouting: return markdownToRawText(response.value);
    case ChatResponseType.SchedulingAssistant: return ''; // TODO: Implement
    case ChatResponseType.SmartRouting: return '';
    case ChatResponseType.BIFindQuotes: return markdownToRawText(response.value);
    case ChatResponseType.BIFindQuantAnalyses: return markdownToRawText(response.value);
    case ChatResponseType.BIChartQuantAnalyses: return response.data.chart.response; // TODO: Implement
    case ChatResponseType.FormWorkflow: return response.value;
    case ChatResponseType.SegmentationTagsNeeded: return response.value;
    case ChatResponseType.SegmentationQuestionsNeeded: return response.value;
    case ChatResponseType.SegmentationComplete: return response.value;
    case ChatResponseType.SegmentationCancelled: return response.value;
    default: {
      throw new UnreachableCaseError(response);
    }
  }
}